import {hostByBrandByEnv} from '@yandex-delivery/shared/network'
import {attachYmaps3React} from './attachYmaps3React'
import {MapsContextLoadedValue} from './context'
import {Maps} from './types'
import {Brand} from '@yandex-delivery/shared/types'

const API_KEY = '0e09d1be-3b8d-44b4-9d0e-eb3a3fd93aea'
const getUrl = ({lang, brand}: LoadYmapsApiProps) => {
  const mapsHost = hostByBrandByEnv[brand].production.maps.default

  return `https://${mapsHost}/3.0/?apikey=${API_KEY}&lang=${lang}`
}

const loadScript = (url: string) =>
  new Promise((resolve, reject) => {
    const script = document.createElement('script')

    script.onload = resolve
    script.onerror = reject
    script.src = url

    document.body.appendChild(script)
  })

let loadPromise: Promise<MapsContextLoadedValue>

type LoadYmapsApiProps = {
  brand: Brand
  lang: string
}

export const loadYmapsApi = (props: LoadYmapsApiProps) => {
  const {lang, brand} = props

  if (!loadPromise) {
    loadPromise = new Promise<Maps>((resolve, reject) => {
      loadScript(getUrl(props))
        .then(() => {
          const mapsKey = brand === 'yango' ? 'yangomaps' : 'ymaps3'
          const mapsInstance = window[mapsKey]

          mapsInstance ? mapsInstance.ready.then(() => resolve(mapsInstance)) : reject(`"${mapsKey}" not defined`)
        })
        .catch(reject)
    }).then(res => attachYmaps3React(res, brand).then(components => ({loaded: true, components, ymaps3: res, lang})))
  }

  return loadPromise
}
